import { LegalDocumentPage } from '@/pages/legal/legal-document-page';

export const CookiePolicyPage = () => <LegalDocumentPage documentKey="cookies" />;
